import React from 'react';
import { Link } from 'react-router-dom';
import { formatUsd, calculateOrderTotal } from '../config/tiers';
import './OrderSummaryCard.css';

export default function OrderSummaryCard({ tier, quantity }) {
  const { subtotalCents, multiTravelerDiscountCents, totalCents } = calculateOrderTotal(tier, quantity);

  return (
    <div className="card tp-order-summary">
      <div className="tp-order-summary__header">
        <div>
          <h2 className="title-l">{tier.name}</h2>
          <p className="body-s tp-order-summary__tagline">{tier.tagline}</p>
        </div>
        <Link to="/" className="btn-ghost btn tp-order-summary__edit">Edit</Link>
      </div>
      <dl className="tp-order-summary__rows">
        <div className="tp-order-summary__row">
          <dt className="body-m">Per traveler</dt>
          <dd className="body-m">{formatUsd(tier.priceCents)}</dd>
        </div>
        <div className="tp-order-summary__row">
          <dt className="body-m">Travelers</dt>
          <dd className="body-m">{quantity}</dd>
        </div>
        {multiTravelerDiscountCents > 0 && (
          <>
            <div className="tp-order-summary__row">
              <dt className="body-m">Subtotal</dt>
              <dd className="body-m">{formatUsd(subtotalCents)}</dd>
            </div>
            <div className="tp-order-summary__row tp-order-summary__row--discount">
              <dt className="body-m">Multi-traveler discount (10%)</dt>
              <dd className="body-m">-{formatUsd(multiTravelerDiscountCents)}</dd>
            </div>
          </>
        )}
        <div className="tp-order-summary__row tp-order-summary__row--total">
          <dt className="title-m">Total</dt>
          <dd className="title-m">{formatUsd(totalCents)}</dd>
        </div>
      </dl>
    </div>
  );
}
